import Vue from 'vue';
import Vuex from 'vuex';
import user from "./user";
import api from './api';
import common from './common';
import plan from './plan';
import note from './note';
import dict from './dict';
import finance from './finance';
import feed from './feed';
import media from './media';
import diary from './diary';
import chat from './chat';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        common,
        api,
        user,
        plan,
        note,
        dict,
        finance,
        feed,
        media,
        diary,
        chat
    }
})
